import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'
import RightContentEmployee from 'modules/react/signup/RightContentEmployee'

export default function Step1RightContent () {

  const { course } = useContext(SignupContext)

  return (
    <>
      <div className="title title--h4">Du bliver kontaktet af en vejleder</div>

      <div className="wysiwyg">Når du har udfyldt dine oplysninger, vil en af vores vejledere kontakte dig for en
        samtale om dine ønsker og mål
      </div>

      <div className="title title--h6">Vores vejledere</div>
      <div className="wysiwyg">Vores vejledere er uddannede i dyleksi og arbejdet med læse- og skrivevanskeligheder. De
        hjælper dig med at tilrettelægge dit undervisningsforløb, De kan også teste dig for ordblindhed
      </div>

      <RightContentEmployee/>
    </>
  )
}